import { render } from "./newsletter-modal.vue?vue&type=template&id=42c51b14"
import script from "./newsletter-modal.vue?vue&type=script&lang=js"
export * from "./newsletter-modal.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/bio-effect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__